import React from 'react';
import classnames from 'classnames';
import HiddenIcon from '../../../Icons/Hidden';
import { IconSize } from '../../../Icons/IconWrap';
import Flex from '../../../Flex';
import { useFlag } from '../../../redux/flags/hooks/useFlag';
import { getPremiumFolderProperties, getBlurredThumbStyles, } from '../../_helpers';
import s from './Hidden.scss';
var HiddenDumbView = function (_a) {
    var className = _a.className, width = _a.width, height = _a.height, deviation = _a.deviation;
    var canHavePremium = useFlag('premium_folders');
    var isPremiumLocked = getPremiumFolderProperties(deviation, canHavePremium).isPremiumLocked;
    return (React.createElement("div", { className: classnames(s['root'], className), style: {
            width: width || height,
            height: height || width,
        } },
        isPremiumLocked && (React.createElement("div", { className: s['blurred-thumb'], style: getBlurredThumbStyles(deviation) })),
        !isPremiumLocked && (React.createElement(Flex, { className: s['blocked'], justifyContent: "center", alignItems: "center" },
            React.createElement(HiddenIcon, { size: IconSize.HUGE })))));
};
HiddenDumbView.displayName = 'HiddenDumbView';
export default HiddenDumbView;
//# sourceMappingURL=Hidden.js.map